import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PLACEMENT_ROUTES = ['/onboarding', '/placement-test-intro', '/placement-test-topics', '/placement-test', '/placement-result', '/debug-quiz'];

const PrivateRoute = () => {
  const isAuthenticated = !!localStorage.getItem('accessToken');
  const hasCompletedPlacement = localStorage.getItem('hasCompletedPlacement') === 'true';
  const location = useLocation();

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (!hasCompletedPlacement && !PLACEMENT_ROUTES.includes(location.pathname)) {
    return <Navigate to="/onboarding" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
